export const messages = {
  login: {
    default: {
      title: "Bienvenido de nuevo!",
      message: "Validando ingreso...",
      forgotText: "¿Olvidaste la contraseña?",
      error: "No es posible establecer la conexión con el servidor en este momento",
      alert: "Por favor recargue la página e intente nuevamente",
      form: {
        emailPlaceholder: "Ingresa la direccion de correo...",
        passwordPlaceholder: "Contraseña",
        buttonText: "Ingresar"
      }
    }
  },
  forgotPassword:{
    default:{
      title: "¿Olvidaste la contraseña?",
      message: "Lo sabemos, esas cosas pasan. Solo ingresa tu dirección de correo electrónico y te enviaremos un link de recuperación!",
      error: "No es posible establecer la conexión con el servidor en este momento",
      accountText: " ¿Tienes una cuenta? Ingresa ahora!",
      form: {
        emailPlaceholder: "Ingresa la direccion de correo...",
        buttonText: "Recuperar contraseña"
      }
    }
  },
  changePassword: {
    forced: {
      title: "Para continuar es necesario asignar su contraseña",
      message: "Su contraseña actual es su número de documento. Por seguridad, debe establecer una nueva contraseña para continuar.",
      form: {
        newPasswordPlaceholder: "Nueva contraseña",
        emailPlaceholder: "Ingresa la direccion de correo...",
        oldPasswordPlaceholder: "Contraseña actual",
        confirmPasswordPlaceholder: "Confirmar nueva contraseña",
        buttonText: "Asignar contraseña"
      }
    },
    generic: {
      title: "Actualizar Contraseña",
      message: "Ingrese su información actual y la nueva contraseña que desea establecer.",
      form: {
        emailPlaceholder: "Ingresa la dirección de correo...",
        oldPasswordPlaceholder: "Contraseña actual",
        newPasswordPlaceholder: "Nueva contraseña",
        confirmPasswordPlaceholder: "Confirmar nueva contraseña",
        buttonText: "Actualizar contraseña"
      }
    }
  }
}
